import React from "react";
import { Github, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-32" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="overline mb-2">[ END OF TRANSMISSION ]</p>
          <p className="font-display font-bold text-lg tracking-tight">Sidharth Kumar Pradhan</p>
          <p className="text-fog-300 text-sm mt-1">© {new Date().getFullYear()} — built with agentic intent.</p>
        </div>
        <div className="flex items-center gap-5">
          <a href="https://github.com/sidharthkumarpradhan" target="_blank" rel="noreferrer" className="text-fog-300 hover:text-volt" data-testid="footer-github">
            <Github className="w-5 h-5" />
          </a>
          <a href="https://www.linkedin.com/in/sidharthkumarpradhan" target="_blank" rel="noreferrer" className="text-fog-300 hover:text-volt" data-testid="footer-linkedin">
            <Linkedin className="w-5 h-5" />
          </a>
          <a href="mailto:edu.sidharth@gmail.com" className="text-fog-300 hover:text-volt" data-testid="footer-email">
            <Mail className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
